import { EOrderStatusName } from 'nexchange-service/module/order'
import { SeoTrackingEvent } from 'nexchange-service/module/seo'

type TOrderDetails = {
    isOrderFlowPersisted: boolean
    orderId: string
    pairName: string
    amountEur: number
    userRefCode: string
    referralToken: string
}

type TUserDetails = {
    username: string
}

type TOrderStatusChangeEventProps = {
    orderStatusName: EOrderStatusName
    orderDetails: TOrderDetails
    userDetails: TUserDetails
}

interface IOrderStatusChangeEvent extends SeoTrackingEvent {
    eventName: string
    orderStatus: EOrderStatusName
    orderDetails: TOrderDetails
}

const orderStatusChangeEventName = 'OrderStatusChange'

class OrderStatusChangeEvent implements IOrderStatusChangeEvent {
    eventName = orderStatusChangeEventName
    orderStatus: EOrderStatusName
    orderDetails: TOrderDetails
    userDetails: TUserDetails

    constructor({ orderStatusName, orderDetails, userDetails }: TOrderStatusChangeEventProps) {
        const { isOrderFlowPersisted = false } = orderDetails

        this.orderStatus = orderStatusName
        this.orderDetails = { ...orderDetails, isOrderFlowPersisted }
        this.userDetails = { ...userDetails }
    }
}

export { OrderStatusChangeEvent }
